export const DOMAIN_HEADER = ["id", "domain"];
